import _ from 'lodash';
import React from 'react';
import { WppSideModal, WppTypography, WppActionButton, WppIconExternalLink, WppAccordion, WppListItem } from 'buildingBlocks';
import { DSP } from 'constantsBase';
import { Flight } from 'utils/types';
import { getDspLinkForFlight, openAllDspLinks } from 'containers/StrategiesList/utils';
import { getDisplayName } from 'containers/StrategyWizard/utils';
import { dspQuickLinkStyles } from './style';
import 'containers/StrategiesList/style.scss';

const {
  quickLinkContainer,
  quickLinkSection,
  quickLinkList,
  modalHeader,
  accordionContent,
  linkButton,
  openAllButton,
  dspTitle,
  accordionContainer,
  linkLabel,
} = dspQuickLinkStyles;

type DspQuickLinkModalProps = {
  isOpen: boolean
  onClose: () => void
  flightsData: Array<Flight>
};

const DspQuickLinkModal: React.FC<DspQuickLinkModalProps> = ({ isOpen, onClose, flightsData }) => {
  const flightsByDsp = _.groupBy(_.values(flightsData), 'dsp');

  const handleOpenAll = (dspFlights: Array<Flight>) => {
    openAllDspLinks(dspFlights);
  };

  return (
    <WppSideModal
      open={isOpen}
      size="xl"
      className="dsp-quick-links-modal"
      onWppSideModalClose={onClose}
    >
      <div slot="header" style={modalHeader}>
        <WppTypography type="xl-heading">DSP Quick Links</WppTypography>
      </div>
      <div style={quickLinkContainer} slot="body">
        <div style={quickLinkSection}>
          <div style={quickLinkList}>
            {_.map(flightsByDsp, (dspFlights, dspId) => {
              const dspContent = DSP.getById(_.toNumber(dspId));
              const dspDisplayName = _.get(dspContent, 'code', '');
              return (
                <WppAccordion
                  key={dspId}
                  size="s"
                  id={`dsp-quick-link-accordion-${dspId}`}
                  expanded
                  withDivider={false}
                  style={accordionContainer}
                  className="dspQuickLinkAccordion"
                >
                  <WppTypography tag="span" slot="header" type="s-strong" style={dspTitle}>
                    {dspDisplayName}
                  </WppTypography>
                  <WppActionButton
                    variant="secondary"
                    style={openAllButton}
                    onClick={() => handleOpenAll(dspFlights)}
                    slot="actions"
                  >
                    Open All
                  </WppActionButton>
                  <div style={accordionContent}>
                    {_.map(dspFlights, (flight) => {
                      const dsplLink = getDspLinkForFlight(flight);
                      const labelText = `${getDisplayName(flight.externalType)} | ${flight.name} | ${flight.externalId}`;
                      return (
                        <WppListItem
                          key={`${flight.id}-${flight.externalId}`}
                          className="dspFlightQuickLinkButton"
                          onClick={() => dsplLink && window.open(dsplLink, '_blank')}
                          style={linkButton}
                        >
                          <div slot="label" style={linkLabel}>
                            {labelText}
                          </div>
                          <WppIconExternalLink slot="right" />
                        </WppListItem>
                      );
                    })}
                  </div>
                </WppAccordion>
              );
            })}
          </div>
        </div>
      </div>
    </WppSideModal>
  );
};

export default DspQuickLinkModal;
